export default ({
  path: "/onboarding",
  name: "onboarding",
  component: () => import("@/views/onboarding/Onboarding.vue"),
  meta: {
    title: "Onboarding - Self-Assessment and Quality Improvement Planning Portal"
  },
  children: [
    {
      path: "services",
      name: "onboarding-services",
      component: () => import("@/views/onboarding/OnboardingServices.vue"),
      meta: {
        protected: true,
        title: "Onboarding - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "educators",
      name: "onboarding-users",
      component: () => import("@/views/onboarding/OnboardingUsers.vue"),
      meta: {
        protected: true,
        title: "Onboarding - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "complete",
      name: "onboarding-complete",
      component: () => import("@/views/onboarding/OnboardingComplete.vue"),
      meta: {
        protected: true,
        title: "Onboarding - Self-Assessment and Quality Improvement Planning Portal"
      }
    }
  ]
})